import { useEffect, useState } from 'react';
import './GoToTop.css';

export function GoToTop() {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const max = Math.max(
        document.documentElement.scrollHeight - window.innerHeight,
        1,
      );
      setVisible(y > 400);
      setProgress(Math.min(100, Math.round((y / max) * 100)));
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      className={`ts-go-top${visible ? ' is-visible' : ''}`}
      aria-label="العودة إلى الأعلى"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      style={
        {
          '--ts-go-top-progress': `${progress}%`,
        } as React.CSSProperties
      }
    >
      <span className="ts-go-top__ring" aria-hidden="true" />
      <span className="ts-go-top__icon" aria-hidden="true">
        <i className="fas fa-arrow-up" />
      </span>
    </button>
  );
}
